<div *ngIf="showSpinner" id="loadingConSmall" class="loading-div-small">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
<div class="d-flex flex-column" *ngIf="!showSpinner">
    <div class="d-flex mt-3">
        <div>
            <img class="img-responsive" width="128" height="128"
                src="http://s7d2.scene7.com/is/image/ABS/{{ offerDetailsPznData?.imageId }}?$ecom-product-card-desktop$&amp;defaultImage=Not_Available"
                alt="{{ offerDetailsPznData?.offerId }}">
        </div>
        <div class="ml-3">
            <div class="d-flex flex-column">
                <div class="price-lg">{{ offerDetailsPznData?.forUDescription }}</div>
                <div class="title-xs">{{ offerDetailsPznData?.brand }}</div>
                <div class="body-text">{{ offerDetailsPznData?.ecomDescription }}</div>
                <div class="body-text">{{ dateString }}</div>
            </div>
        </div>
    </div>
    <div>
        <button *ngIf="offerDetailsPznData?.status === 'U' || offerDetailsPznData?.deleted" class="btn btn-lg pds-btn-filled--primary w-100"
            aria-label="Add to list" (click)="addToList()">Add to list</button>
        <button *ngIf="offerDetailsPznData?.status === 'C' && !offerDetailsPznData?.deleted" class="btn btn-lg pds-btn-filled--primary w-100"
            aria-label="Remove from list" (click)="removeFromList()">Remove from list</button>
    </div>
    <hr />
    <div id="offerTermsBody" [ngClass]="{'offer-terms-condition-pzn': true, 'collapsed' : !showAccordion}"
        aria-labelledby="offerTermsHeader" [attr.aria-expanded]="showAccordion" aria-controls="offerTermsBody"
        (click)="toggleAccordion()">
        <div class="d-flex justify-content-between" type="button">
            <span role="heading" aria-level="2" class="offer-terms-text" data-qa="offr-trms-txt">Offer Details</span>
            <span aria-hidden="true" class="svg-caret-down" role="img" data-qa="svg-icn-arrow-dwn"></span>
        </div>
        <div class="cms-offer-terms-conditions" [ngClass]="{'collapse' : !showAccordion}"></div>
    </div>
    <hr />
</div>